module.exports = __webpack_public_path__ + "img/quizz-step-1-4.d89d5633.jpg";